import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-SG', {
    style: 'currency',
    currency: 'SGD'
  }).format(price);
}

export function formatDate(date) {
  return new Intl.DateTimeFormat('en-SG', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(new Date(date));
}

/**
 * Get the full URL for an image path
 * Handles both relative paths (/api/uploads/...) and full URLs
 */
export function getImageUrl(imagePath) {
  if (!imagePath) return '';
  
  // If it's already a full URL (http/https), return as-is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // If it's a relative path, prepend the backend URL
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  
  // Handle paths that start with / or not
  if (imagePath.startsWith('/')) {
    return `${backendUrl}${imagePath}`;
  }
  
  return `${backendUrl}/${imagePath}`;
}